/**
 * Conti e pulizie per lo spostamento di un video dentro l'editor.
 *
 * Sono funzioni pure tenute fuori dal componente perche' sono la parte in cui
 * si sbaglia: l'aritmetica degli indici di Quill e la ripulitura del testo
 * prima di salvarlo.
 */

/** Un blocco dell'editor (un paragrafo, un video, un elenco) con la sua posizione a schermo. */
export interface BloccoEditor {
  /** Indice Quill del primo carattere del blocco. */
  inizio: number;
  /** Indice Quill subito dopo il blocco. */
  fine: number;
  top: number;
  bottom: number;
}

/**
 * Indice a cui reinserire il video dopo averlo tolto dalla posizione di
 * partenza.
 *
 * Il video occupa una posizione sola: togliendolo, tutto quello che sta dopo
 * scala di uno. Senza questo conto, trascinandolo in avanti atterrerebbe un
 * blocco piu' in la' di dove e' stato lasciato.
 */
export function indiceDopoRimozione(origine: number, destinazione: number): number {
  return destinazione > origine ? destinazione - 1 : destinazione;
}

/**
 * Dove finisce il video lasciato all'altezza `y`: prima o dopo il blocco piu'
 * vicino, a seconda di quale metà si e' puntato.
 */
export function indiceRilascio(blocchi: BloccoEditor[], y: number): number | null {
  if (blocchi.length === 0) {
    return null;
  }

  const primo = blocchi[0];
  if (y < primo.top) {
    return primo.inizio;
  }

  for (const blocco of blocchi) {
    if (y <= blocco.bottom) {
      // Sopra la metà del blocco si va prima, sotto si va dopo: e' il
      // comportamento che chiunque si aspetta trascinando qualcosa.
      const meta = blocco.top + (blocco.bottom - blocco.top) / 2;
      return y < meta ? blocco.inizio : blocco.fine;
    }
  }

  return blocchi[blocchi.length - 1].fine;
}

/**
 * Toglie dal testo gli aiuti che servono solo mentre si scrive.
 *
 * `draggable` e `contenteditable` li mette l'editor per rendere il video
 * trascinabile; salvati nell'articolo, `contenteditable` rende invalida la
 * pagina AMP. Gli `span.ql-ui` sono i segnaposto che Quill semina davanti a
 * ogni voce di elenco, e sono l'altra causa storica di pagine AMP rifiutate.
 */
export function testoSenzaAiutiEditor(html: string): string {
  if (!html) {
    return '';
  }
  const documento = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html');
  documento.body.querySelectorAll('span.ql-ui').forEach((span) => span.remove());
  documento.body.querySelectorAll('[draggable]').forEach((nodo) => nodo.removeAttribute('draggable'));
  documento.body.querySelectorAll('[contenteditable]').forEach((nodo) => nodo.removeAttribute('contenteditable'));
  return documento.body.innerHTML;
}
